import React, { useState, useMemo, useEffect } from 'react';
import { API_BASE_URL } from '../../utils';
import './Gallery.css';
import ImageWithSkeleton from './ImageWithSkeleton';




const url = `${API_BASE_URL}/master/assets/uploads/`;

export default React.memo(function Gallery({ gallery = [] }) {
  const [selectedCategory, setSelectedCategory] = useState('All');

  // Extract unique category list
  const categories = useMemo(() => {
    const all = gallery.map((item) => item.category);
    return ['All', ...new Set(all)];
  }, [gallery]);

  // Filtered gallery data
  const filteredGallery = useMemo(() => {
    if (selectedCategory === 'All') return gallery;
    return gallery.filter((item) => item.category === selectedCategory);
  }, [gallery, selectedCategory]);

  // Correct image count per category
  const imageCountByCategory = useMemo(() => {
    const countMap = {};

    gallery.forEach(item => {
      const cat = item.category || 'Uncategorized';
      const imgCount = item.images?.length || 0;
      countMap[cat] = (countMap[cat] || 0) + imgCount;
    });

    // Total image count for "All"
    countMap["All"] = gallery.reduce((acc, item) => acc + (item.images?.length || 0), 0);

    return countMap;
  }, [gallery]);




  return (
    <>
      <h1 className='vcdp-gallery-title'>Gallery</h1>

      <div className="vcdp-gallery-empty-container">
        {gallery.length === 0 ? (
          <div className="vcdp-gallery-empty-content">
            <h1>No Photos Available</h1>
            <p>
              We’re working on an exciting gallery designed to give you the best value and experience.
            </p>
            <img
              src="https://illustrations.popsy.co/gray/web-design.svg"
              alt="Coming Soon"
              className="vcdp-gallery-empty-image"
            />
          </div>
        ) : (
          <div className="vcdp-gallery-container">
            {/* Filter Buttons */}
            <div className="vcdp-gallery-filters">
              {categories.map((cat, i) => (
                <span
                  key={i}
                  className={`vcdp-filter-button ${selectedCategory === cat ? 'vcdp-active' : ''}`}
                  onClick={() => setSelectedCategory(cat)}
                >
                  {cat} {'\u0028'}{imageCountByCategory[cat] || 0}{'\u0029'}
                </span>
              ))}
            </div>

            <div className='vcdp-gallery-items-container'>
              {/* Filtered Items */}
              {filteredGallery.map((item, index) => (
                <div key={index} className="vcdp-gallery-item">
                  <h2>{item.category}</h2>
                  <div className="vcdp-gallery-images">
                    {item.images.map((image, imgIndex) => (
                      <ImageWithSkeleton
                        key={imgIndex}
                        src={`${url}${image.img}`}
                        alt={`Gallery item ${imgIndex + 1}`}
                        caption={`${item.category}, Image ${imgIndex + 1} of ${item.images.length}`}
                        fancybox="gallery"
                      />
                    ))}
                  </div>
                </div>
              ))}
            </div>
          </div>
        )}
      </div>
    </>
  );
});
